module.exports = __webpack_public_path__ + "img/3.f00f7daf.jpg";